import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import {
    PropertyDefinition, PropertyMappingType,
} from "app/library/layout-builder";
import { LibraryAppointmentProps } from "./types";

export class LibraryAppointmentDefinitions extends CmsReactComponent<LibraryAppointmentProps> {
    static defaultProps = {};

    static schemaName = "library-appointment";

    static propertyDefinitions: PropertyDefinition[] = [{
        name: "title",
        mapping: {
            type: PropertyMappingType.String,
        },
        text: "Başlık",
    },
    {
        name: "description",
        mapping: {
            type: PropertyMappingType.Textarea,
        },
        text: "Açıklama",
    },
    {
        name: "termsOfUseText",
        mapping: {
            type: PropertyMappingType.Html,
        },
        text: "Kullanım Koşulları Metni",
    },
    {
        name: "kvkkText",
        mapping: {
            type: PropertyMappingType.Html,
        },
        text: "KVKK Metni",
    },
    {
        name: "popupTitle",
        mapping: {
            type: PropertyMappingType.String,
        },
        text: "Popup Başlığı",
    },
    {
        name: "popupDescription",
        mapping: {
            type: PropertyMappingType.Html,
        },
        text: "Popup Metni",
    }];
}
